import { useTranslation } from 'react-i18next';
import { Documentation } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import TextCellWithIcon from '@lib/components/Table/commonComponents/TextCell/TextCellWithIcon';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import { CellProps } from '@lib/components/Table/types';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import { dateFormat } from '@lib/enums/dateTime';
import isRenewalUpdateRequired from 'routes/Documentation/utils/isRenewalUpdateRequired';
import styles from './RenewalDeadlineCell.module.scss';

export default function RenewalDeadlineCell(props: CellProps<Documentation>) {
  const { t } = useTranslation();
  const { item } = props;
  const value = item.renewalDeadlineDate
    ? getFormattedDate(item.renewalDeadlineDate, dateFormat)
    : '-';
  const cellProps = { ...props, value };

  if (!isRenewalUpdateRequired(item.renewalDeadlineDate)) {
    return <TextCell {...cellProps} />;
  }

  return (
    <TextCellWithIcon
      {...cellProps}
      iconPosition="right"
      icon={
        <Tooltip body={t('update-required')}>
          <MaterialIcon
            icon="warning"
            size="md-18"
            symbolsOutlined
            filled
            className={styles.warningIcon}
          />
        </Tooltip>
      }
    />
  );
}
